<template>
    <form
        @submit.prevent="store"
        @keydown="form.errors.clear($event.target.name)"
        class="form-horizontal fr-absolute"
        enctype="multipart/form-data"
        autocomplete="off"
        novalidate
    >
        <form-date-picker
            :form="form"
            :error="form.errors.get('done_at')"
            :value="field('done_at')"
            v-model="form.done_at"
            name="done_at"
            label="action_date"
            initial-view="day"
            required
        />

        <form-input
            :form="form"
            :error="form.errors.get('organisation')"
            :value="field('organisation')"
            v-model="form.organisation"
            label="organisation"
            name="organisation"
            required
            autofocus
        />

        <form-input
            :form="form"
            :error="form.errors.get('position')"
            :value="field('position')"
            label="position"
            name="position"
            required
        />

        <form-select
            v-model="selectedType"
            :options="types"
            :loading="!types.length"
            :disabled="!types.length"
            :error="form.errors.get('type_id')"
            object-name-key="value"
            track-by="id"
            label="application_type"
            label-classes="col-md-3 col-xl-2 col-sm-12 no-wrap"
            name="type"
            required
        />

        <form-select
            v-model="selectedStatus"
            :options="statuses"
            :loading="!statuses.length"
            :disabled="!statuses.length"
            :error="form.errors.get('status_id')"
            track-by="id"
            object-name-key="value"
            name="status"
            required
        />

        <form-textarea
            :form="form"
            :error="form.errors.get('next_action')"
            label="followup_action"
            name="next_action"
            required
        />

        <div class="form-group fr-absolute">
            <input
                @click.prevent="store"
                :value="uLang('app.save')"
                :disabled="form.busy"
                class="btn btn-brand"
                type="submit"
            />
        </div>
    </form>
</template>

<script>
    import Form from "~/Form/Form";
    import FormMixin from "~/mixins/form";
    import { mapGetters } from 'vuex'

    export default {
        name: "ApplicationActivitiesForm",
        mixins: [FormMixin],
        props: {
            id: {
                required: false,
            },
            entityId: {
                required: true,
            },
        },
        data() {
            return {
                entity: "application-activity",
                hasSingleStoreMethod: true,
                swal: false,
                statuses: [],
                types: [],
                errors: {},
                selectedType: null,
                selectedStatus: null,
                form: new Form({
                    relation_id: this.entityId,
                    done_at: new Date(),
                    organisation: '',
                    next_action: '',
                    position: '',
                    type_id: null,
                    status_id: null,
                }),
            };
        },
        computed: {
            ...mapGetters(['authUser'])
        },
        created() {
            this.$on('afterStore', this.afterStore);
            this.$on('afterUpdate', this.afterUpdate);
            this.$on('afterRetrieve', this.afterRetrieve);
        },
        mounted() {
            this.getTypes();
            this.getStatuses();
        },
        methods: {
            afterUpdate() {
                if ($hasType('candidate')) {
                    this.$router.push({
                        name: 'dashboard',
                    })
                } else {
                    this.$router.push({
                        name: 'admin.relations.view',
                        params: { 'id': this.entityId }
                    })
                }
            },
            afterStore(response) {
                this.form.fill({
                    done_at: '',
                    organisation: '',
                    next_action: '',
                    position: '',
                    type_id: null,
                    status_id: null,
                });
                this.selectedType = null
                this.selectedStatus = null

                this.$emit('applicationActivityCreated', response)
            },
            afterRetrieve(data) {
                if (this.isUpdate()) {
                    this.form.done_at = new Date(data.done_at)
                    this.selectedType = data.type
                    this.selectedStatus = data.status
                }
            },
            async getTypes() {
                const { data } = await window.axios.get(route('application-activity-types.all'));

                this.types = data
            },
            async getStatuses() {
                const { data } = await window.axios.get(route('application-statuses.all'));

                this.statuses = data
            },
        },
        watch: {
            selectedType(selectedType) {
                this.form.type_id = selectedType.id
            },
            selectedStatus(selectedStatus) {
                this.form.status_id = selectedStatus.id
            }
        },
    }
</script>

<style>
    .no-wrap {
        white-space: nowrap;
    }
</style>
